export const AI_ASSISTANT_EVENTS = {
  AI_MAIN: "ai_main",
  AI_OPTIONS: "ai_options",
  AI_SEND: "ai_send",
};
